import customAxios from "../../customAxios";
import { DELETE_CATEGORY } from "../../routes";

const deleteCategory = async (userId: string) => {
  try {
    return (await customAxios.delete(DELETE_CATEGORY + `/${userId}`)).data;
  } catch (error: any) {
    console.log({ DELETE_CATEGORY: error });
    return false;
  }
};

export default deleteCategory;
